import { render, staticRenderFns } from "./MobileImageUpload.vue?vue&type=template&id=96a5578c&scoped=true"
import script from "./MobileImageUpload.vue?vue&type=script&lang=js"
export * from "./MobileImageUpload.vue?vue&type=script&lang=js"
import style0 from "./MobileImageUpload.vue?vue&type=style&index=0&id=96a5578c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a5578c",
  null
  
)

export default component.exports